import React from 'react'
import { Typography, Box } from '@mui/material'
import SignInBg from 'assets/bg/signin.jpg'
import SignUpBg from 'assets/bg/signup.jpg'
import LoggedOutControls from 'components/Auth/LoggedOutControls'

const sx = {
  root: {
    backgroundColor: '#fff',
    minHeight: '100vh',
    display: 'flex',
    flex: 1,
  },
  infoSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40%',
    backgroundSize: 'cover',
    [theme => theme.breakpoints.down(813)]: {
      display: 'none',
    },
  },
  formSection: {
    width: '61%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgb(248, 250, 251)',
    paddingTop: theme => theme.spacing(9.5),
    [theme => theme.breakpoints.down(813)]: {
      width: '100%',
      padding: '0 50px',
    },
  },
  infoText: {
    textAlign: 'center',
    position: 'fixed',
    top: '50%',
  },
}

const AuthLayout = ({ children, bgType, noAuthHeader }) => {
  const styleWithBackgroudImage = {
    backgroundImage: `url(${bgType === 'signIn' ? SignInBg : SignUpBg})`,
  }

  return (
    <Box sx={sx.root}>
      {!noAuthHeader && <LoggedOutControls />}
      <Box sx={sx.infoSection} style={styleWithBackgroudImage}>
        <Box sx={sx.infoText}>
          <Typography variant="h3">
            <span className="color-white primary-header">Connecting small and big businesses, from A-Z.</span>
          </Typography>
        </Box>
      </Box>
      <Box sx={sx.formSection}>{children}</Box>
    </Box>
  )
}

export default AuthLayout
